import api from '@pray/shared/utils/api';

import type { RecurringPushAudienceOptions } from './types';

// GET …/campaigns/recurring-push/audience-options — the picker's lead campaigns +
// lead lists with counts. `sendObjectResponse(res, { lead_campaigns, lead_lists })`,
// so the unwrapped payload is the two-array object itself (no `object` wrapper).
//
// We also surface an authoritative server clock as `server_now` so the
// "Next 5 sends" preview can anchor to it rather than a skewed device clock
// (spec §5). Source = the HTTP `Date` response header — no response-body
// contract change, so the documented envelope shape is untouched. The
// create/edit screen (where the preview lives) already fetches this endpoint.
export async function getRecurringPushAudienceOptions({
  artistId,
}: {
  artistId: string;
}): Promise<RecurringPushAudienceOptions & { server_now: string | null }> {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/audience-options`;
  const response = await api.executeGetRequest<{ data: RecurringPushAudienceOptions }>(url);
  const dateHeader = (response.headers as Record<string, string> | undefined)?.date ?? null;
  const serverNow = dateHeader ? new Date(dateHeader) : null;
  return {
    ...response.data.data,
    server_now: serverNow && !Number.isNaN(serverNow.getTime()) ? serverNow.toISOString() : null,
  };
}
